import { Folder, Video, ExternalLink, Link2, Globe, FileText, Image } from "lucide-react";

// Single source of truth for how a portfolio_media type is labeled/iconified,
// shared by the gallery card badges, the package board and every scope section.
// `addLabel` is what the "add an item" dialog calls this kind of link.
export const LINK_TYPE_META = {
  folder_link: { label: "Files", Icon: Folder, testId: "files", addLabel: "Folder (Dropbox, Drive…)" },
  dropbox_link: { label: "Files", Icon: Folder, testId: "files", addLabel: "Dropbox folder" },
  video_link: { label: "Video", Icon: Video, testId: "video", addLabel: "Video (Vimeo, YouTube…)" },
  vexos_link: { label: "VEXOS", Icon: ExternalLink, testId: "vexos", addLabel: "VEXOS platform link" },
  web_link: { label: "Website", Icon: Globe, testId: "website", addLabel: "Live web page" },
  doc_link: { label: "Document", Icon: FileText, testId: "document", addLabel: "Deck or document link" },
  other_link: { label: "Link", Icon: Link2, testId: "link", addLabel: "Other link" },
  document: { label: "PDF", Icon: FileText, testId: "pdf", addLabel: "PDF" },
  image: { label: "Image", Icon: Image, testId: "image", addLabel: "Image" },
};

export function getLinkMeta(mediaType) {
  return LINK_TYPE_META[mediaType] || { label: "Link", Icon: Link2, testId: "link" };
}
